import { NO, UITextView } from "uicore-ts"
import { RHTextField } from "./RHTextField"


export class RHTextArea extends RHTextField {
    
    
    constructor(elementID?: string, viewHTMLElement = null) {
    
        super(elementID, viewHTMLElement, UITextView.type.textArea)
    
        this.viewHTMLElement.removeAttribute("type")
    
        this.style.overflow = "auto"
        this.style.webkitUserSelect = "text"
    
        this.pausesPointerEvents = NO
    
    }
    
    
    override get viewHTMLElement(): HTMLTextAreaElement & HTMLInputElement {
    
        // @ts-ignore
        return super.viewHTMLElement
    
    }
    
    
}







































